// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes page-transition-slide-in {
  from {
    transform: translateX(7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-reverse-slide-in {
  from {
    transform: translateX(-7.5rem);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes page-transition-slide-out {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-7.5rem);
  }
}
@keyframes width-grow {
  from {
    transform: scaleX(0.001);
  }
  to {
    transform: scaleX(1);
  }
}
@keyframes width-shrink {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0.001);
  }
}
@keyframes height-grow {
  from {
    transform: scaleY(0.0001);
  }
  to {
    transform: scaleY(1);
  }
}
@keyframes height-fade-and-grow {
  from {
    opacity: 0;
    transform: scaleY(0.0001);
  }
  to {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes height-shrink {
  from {
    transform: scaleY(1);
  }
  to {
    transform: scaleY(0.001);
  }
}
@keyframes roll-in {
  from {
    opacity: 0;
    transform: translateX(10rem) rotate(500deg);
  }
  to {
    opacity: 1;
    transform: translateX(0) rotate(0);
  }
}
@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(5rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateX(5rem);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slide-out {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-5rem);
  }
}
@keyframes drop {
  0% {
    transform: translateY(-1rem);
  }
  100% {
    transform: translateY(0);
  }
}
.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
app-root .messaging-dialog[open] .process-explainer {
  will-change: transform;
  animation: height-grow 0.7s ease-in-out normal  backwards;
}
app-root .messaging-dialog[open] .process-explainer h3 {
  will-change: opacity;
  animation: fade-in 0.5s ease-out normal 0.3s backwards;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li .list-text {
  will-change: transform, opacity;
  animation: slide-up 0.4s ease-out normal backwards;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(1) .list-text {
  animation-delay: 0.4s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(2) .list-text {
  animation-delay: 0.7s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(3) .list-text {
  animation-delay: 1s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li::before {
  will-change: opacity;
  animation: fade-in 0.6s ease-out normal backwards;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(1)::before {
  animation-delay: 0.4s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(2)::before {
  animation-delay: 0.7s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(3)::before {
  animation-delay: 1s;
}
app-root .messaging-dialog[open] .process-explainer footer {
  will-change: opacity;
  animation: fade-in 0.3s ease-out normal 1.2s backwards;
}
app-root .messaging-dialog[open] .process-explainer {
  animation-duration: 0.4s;
}
app-root .messaging-dialog[open] .process-explainer h3 {
  animation-delay: 0.3s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(1) .list-text {
  animation-delay: 0.2s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(2) .list-text {
  animation-delay: 0.35s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(3) .list-text {
  animation-delay: 0.5s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(1)::before {
  animation-delay: 0.2s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(2)::before {
  animation-delay: 0.35s;
}
app-root .messaging-dialog[open] .process-explainer ol.process-overview li:nth-of-type(3)::before {
  animation-delay: 0.5s;
}
app-root .messaging-dialog[open] .process-explainer footer {
  animation: fade-in 0.4s ease-in-out 0.6s backwards;
}
app-root .messaging-dialog[open] .modal-close {
  animation: fade-in 0.4s ease-in-out 0.7s normal backwards;
}
app-root button.message-modal-open {
  will-change: opacity;
}
app-root button.message-modal-open.show:not(:focus) {
  animation: fade-in 0.3s ease-in 0.1s backwards;
}
app-root button.message-modal-open.hide:not(:focus),
app-root button.message-modal-open.hidden:not(:focus),
app-root button.message-modal-open.modal-is-open,
app-root button.message-modal-open.show.modal-is-open {
  animation: fade-out 0.3s ease-in 0.1s forwards;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/animations.less","webpack://./src/Components/Brand/Messaging/LeadFeed/Modal/ModalAnimation.less","webpack://./src/Styles/utilities.less","webpack://./src/Components/Brand/ProcessOverview/LeadFeed/ProcessOverviewAnimation.less"],"names":[],"mappings":"AACE;EACE;IACE,UAAA;ECAJ;EDGE;IACE,UAAA;ECDJ;AACF;ADIE;EACE;IACE,UAAA;ECFJ;EDKE;IACE,UAAA;ECHJ;AACF;ADME;EACE;IACE,6BAAA;ECJJ;EDOE;IACE,wBAAA;ECLJ;AACF;ADQE;EACE;IACE,8BAAA;ECNJ;EDSE;IACE,wBAAA;ECPJ;AACF;ADUE;EACE;IACE,wBAAA;ECRJ;EDWE;IACE,8BAAA;ECTJ;AACF;ADYE;EACE;IACE,wBAAA;ECVJ;EDaE;IACE,oBAAA;ECXJ;AACF;ADcE;EACE;IACE,oBAAA;ECZJ;EDeE;IACE,wBAAA;ECbJ;AACF;ADgBE;EACE;IACE,yBAAA;ECdJ;EDiBE;IACE,oBAAA;ECfJ;AACF;ADkBE;EACE;IACE,UAAA;IACA,yBAAA;EChBJ;EDmBE;IACE,UAAA;IACA,oBAAA;ECjBJ;AACF;ADoBE;EACE;IACE,oBAAA;EClBJ;EDqBE;IACE,wBAAA;ECnBJ;AACF;ADsBE;EACE;IACE,UAAA;IACA,2CAAA;ECpBJ;EDsBE;IACE,UAAA;IACA,kCAAA;ECpBJ;AACF;ADuBE;EACE;IACE,UAAA;IACA,2BAAA;ECrBJ;EDuBE;IACE,UAAA;IACA,wBAAA;ECrBJ;AACF;ADwBE;EACE;IACE,UAAA;IACA,2BAAA;ECtBJ;EDwBE;IACE,UAAA;IACA,wBAAA;ECtBJ;AACF;ADyBE;EACE;IACE,UAAA;IACA,wBAAA;ECvBJ;EDyBE;IACE,UAAA;IACA,4BAAA;ECvBJ;AACF;AD0BE;EACE;IACE,4BAAA;ECxBJ;ED2BE;IACE,wBAAA;ECzBJ;AACF;ACpGA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AD0HF;AAxIA;EEOI,sBAAA;EACA,yDAAA;AFoIJ;AA5IA;EEWM,oBAAA;EACA,sDAAA;AFoIN;AAhJA;EEkBU,+BAAA;EACA,kDAAA;AFiIV;ACzDG;EACC,qBAAA;AD2DJ;AC5DG;EACC,qBAAA;AD8DJ;AC/DG;EACC,mBAAA;ADiEJ;AEtIQ;EACE,oBAAA;EACA,iDAAA;AFwIV;ACtEG;EACC,qBAAA;ADwEJ;ACzEG;EACC,qBAAA;AD2EJ;AC5EG;EACC,mBAAA;AD8EJ;AA1KA;EEgCM,oBAAA;EACA,sDAAA;AF6IN;AA9KA;EAIM,wBAAA;AA6KN;AAjLA;EAOQ,qBAAA;AA6KR;ACzFG;EACC,qBAAA;AD2FJ;AC5FG;EACC,sBAAA;AD8FJ;AC/FG;EACC,qBAAA;ADiGJ;AClGG;EACC,qBAAA;ADoGJ;ACrGG;EACC,sBAAA;ADuGJ;ACxGG;EACC,qBAAA;AD0GJ;AAtMA;EAgBQ,kDAAA;AAyLR;AAzMA;EAoBM,yDAAA;AAwLN;AA5MA;EAwBI,oBAAA;AAuLJ;AArLI;EACE,8CAAA;AAuLN;AApLI;;;;EAIE,8CAAA;AAsLN","sourcesContent":["app-root {\n  @keyframes fade-in {\n    from {\n      opacity: 0;\n    }\n\n    to {\n      opacity: 1;\n    }\n  }\n\n  @keyframes fade-out {\n    from {\n      opacity: 1;\n    }\n\n    to {\n      opacity: 0;\n    }\n  }\n\n  @keyframes page-transition-slide-in {\n    from {\n      transform: translateX(7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-reverse-slide-in {\n    from {\n      transform: translateX(-7.5rem);\n    }\n\n    to {\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes page-transition-slide-out {\n    from {\n      transform: translateX(0);\n    }\n\n    to {\n      transform: translateX(-7.5rem);\n    }\n  }\n\n  @keyframes width-grow {\n    from {\n      transform: scaleX(0.001);\n    }\n\n    to {\n      transform: scaleX(1);\n    }\n  }\n\n  @keyframes width-shrink {\n    from {\n      transform: scaleX(1);\n    }\n\n    to {\n      transform: scaleX(0.001);\n    }\n  }\n\n  @keyframes height-grow {\n    from {\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-fade-and-grow {\n    from {\n      opacity: 0;\n      transform: scaleY(0.0001);\n    }\n\n    to {\n      opacity: 1;\n      transform: scaleY(1);\n    }\n  }\n\n  @keyframes height-shrink {\n    from {\n      transform: scaleY(1);\n    }\n\n    to {\n      transform: scaleY(0.001);\n    }\n  }\n\n  @keyframes roll-in {\n    from {\n      opacity: 0;\n      transform: translateX(10rem) rotate(500deg);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0) rotate(0);\n    }\n  }\n\n  @keyframes slide-up {\n    from {\n      opacity: 0;\n      transform: translateY(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  @keyframes slide-in {\n    from {\n      opacity: 0;\n      transform: translateX(5rem);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n\n  @keyframes slide-out {\n    from {\n      opacity: 1;\n      transform: translateX(0);\n    }\n    to {\n      opacity: 0;\n      transform: translateX(-5rem);\n    }\n  }\n\n  @keyframes drop {\n    0% {\n      transform: translateY(-1rem);\n    }\n\n    100% {\n      transform: translateY(0);\n    }\n  }\n}\n\n.cubic-slide-in-animation(@delay: 0s) {\n  animation: 0.25s ease-in normal backwards @delay fade-in,\n    0.3s cubic-bezier(0.39, 0.67, 0.61, 0.96) normal backwards @delay page-transition-slide-in;\n}\n.cubic-reverse-slide-in-animation(@delay: 0s) {\n  animation: 0.4s ease-in normal backwards @delay fade-in,\n    0.2s cubic-bezier(0.23, 0.06, 0.55, 0.42) normal backwards @delay\n      page-transition-reverse-slide-in;\n}\n.cubic-slide-out-animation(@delay: 0s) {\n  animation: 0.3s ease-in @delay forwards fade-out,\n    0.3s cubic-bezier(0.23, 0.06, 0.55, 0.42) @delay forwards page-transition-slide-out;\n}\n","@import '../../../../Brand/ProcessOverview/LeadFeed/ProcessOverviewAnimation.less';\n\napp-root {\n  .messaging-dialog[open] {\n    .animate-process-explainer-entrance(0);\n    .process-explainer {\n      animation-duration: 0.4s;\n\n      h3 {\n        animation-delay: 0.3s;\n      }\n      ol.process-overview {\n        li {\n          .sequential-delay(3, 0.15s, ~' .list-text', 0.2s);\n          .sequential-delay(3, 0.15s, ~'::before', 0.2s);\n        }\n      }\n      footer {\n        animation: fade-in 0.4s ease-in-out 0.6s backwards;\n      }\n    }\n    .modal-close {\n      animation: fade-in 0.4s ease-in-out 0.7s normal backwards;\n    }\n  }\n  button.message-modal-open {\n    will-change: opacity;\n\n    &.show:not(:focus) {\n      animation: fade-in 0.3s ease-in 0.1s backwards;\n    }\n\n    &.hide:not(:focus),\n    &.hidden:not(:focus),\n    &.modal-is-open,\n    &.show.modal-is-open {\n      animation: fade-out 0.3s ease-in 0.1s forwards;\n    }\n  }\n}\n","@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../../../Styles/colours.less';\n@import '../../../../Styles/animations.less';\n@import '../../../../Styles/utilities.less';\n\n// Mix-ins (must be invoked)\n\n.animate-process-explainer-entrance(@baseDelay: 0s) {\n  .process-explainer {\n    @articleDelay: if(@baseDelay = 0s, ~'', @baseDelay);\n    will-change: transform;\n    animation: height-grow 0.7s ease-in-out normal @articleDelay backwards;\n\n    h3 {\n      will-change: opacity;\n      animation: fade-in 0.5s ease-out normal (@baseDelay + 0.3s) backwards;\n    }\n\n    ol.process-overview {\n      li {\n        .list-text {\n          will-change: transform, opacity;\n          animation: slide-up 0.4s ease-out normal backwards;\n        }\n        .sequential-delay(3, 0.3s, ~' .list-text', @baseDelay + 0.4s);\n\n        &::before {\n          will-change: opacity;\n          animation: fade-in 0.6s ease-out normal backwards;\n        }\n        .sequential-delay(3, 0.3s, ~'::before', @baseDelay + 0.4s);\n      }\n    }\n\n    footer {\n      will-change: opacity;\n      animation: fade-in 0.3s ease-out normal (@baseDelay + 1.2s) backwards;\n    }\n  }\n}\n\n.animate-process-explainer-exit() {\n  .process-explainer {\n    will-change: transform;\n    animation: height-shrink 0.3s ease-in normal 0.1s forwards;\n\n    h3 {\n      will-change: opacity;\n      animation: fade-out 0.2s ease-out normal forwards;\n    }\n\n    ol.process-overview {\n      li {\n        .list-text {\n          will-change: opacity;\n          animation: fade-out 0.2s ease-out normal forwards;\n        }\n\n        &::before {\n          will-change: opacity;\n          animation: fade-out 0.2s ease-out normal forwards;\n        }\n      }\n    }\n\n    footer {\n      will-change: opacity;\n      animation: fade-out 0.3s ease-out normal forwards;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
